import { useContext } from "react";

import { useAppSelector } from "./redux_hooks";

import { FlightAPIContext } from "contexts/flight_api_context";
import { selectIsPresentationView, selectLoading } from "store/selectors/classroom";

export const useIsAlreadyPresent = () => {
  const flightAPI = useContext(FlightAPIContext);
  const isPresentationView = useAppSelector(selectIsPresentationView());
  const isLoading = useAppSelector(selectLoading());
  if (isLoading) {
    return false;
  }
  return flightAPI.userIsAlreadyPresent && !isPresentationView;
};
